import { useContext } from "react";
import { CircleProgress } from "./Overlay";
import { MainPageMaskContext } from "../js/MainPageMaskContent";

const MainPageMask = () => {
    const { showMainPageMask } = useContext(MainPageMaskContext);

    return (
        <>
            {showMainPageMask && <CircleProgress />}
        </>
    );
};

export default MainPageMask;
